/** Canonical booking tag codes for enum filters (bookings list, report slicers). */
export const BOOKING_TAG_FILTER_OPTIONS: { value: string; label: string }[] = [
  { value: "DG", label: "DG" },
  { value: "MSDS", label: "MSDS" },
  { value: "REEFER", label: "Reefer" },
  { value: "OOG", label: "OOG" },
  { value: "HEAVY", label: "Heavy" },
  { value: "ROLLED", label: "Rolled" },
  { value: "PENDING_RELEASE", label: "Pending release" },
  { value: "REBOOKED", label: "Rebooked" },
  { value: "DELAYED", label: "Delayed" },
  { value: "EXW", label: "EXW" },
  { value: "T/S", label: "Transshipment" },
  { value: "DOCUMENTS_ARRIVED", label: "Documents arrived" },
  { value: "DOCUMENTS_MISSING", label: "Documents missing" },
];
